import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestaurantTable } from '../models/restaurantTable.model';
import { CreateRestaurantTableDto } from '../models/dtos/createRestaurantTable.dto';
import { UpdateRestaurantTableDto } from '../models/dtos/updateRestaurantTable.dto';
import { UpdateRestaurantTableStatusDto } from '../models/dtos/updateRestaurantTableStatus.dto';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';
import { RestaurantTableStatus } from '../models/restaurantTable.model';

@Injectable({
  providedIn: 'root',
})
export class RestaurantTableService {
  private readonly baseUrl = `${environment.base_url}/restaurant-tables`;

  constructor(private http: HttpClient) {}

  list(status?: RestaurantTableStatus, page: number = 1): Observable<RestResponse<RestaurantTable[]>> {
    const params: any = { page: String(page) };
    if (status) params.status = status;
    return this.http.get<RestResponse<RestaurantTable[]>>(`${this.baseUrl}/list`, { params });
  }

  find(id: number): Observable<RestResponse<RestaurantTable>> {
    return this.http.get<RestResponse<RestaurantTable>>(`${this.baseUrl}/find/${id}`);
  }

  create(dto: CreateRestaurantTableDto): Observable<RestResponse<RestaurantTable | null>> {
    return this.http.post<RestResponse<RestaurantTable | null>>(`${this.baseUrl}/create`, dto);
  }

  update(id: number, dto: UpdateRestaurantTableDto): Observable<RestResponse<RestaurantTable | null>> {
    return this.http.put<RestResponse<RestaurantTable | null>>(`${this.baseUrl}/update/${id}`, dto);
  }

  updateStatus(id: number, dto: UpdateRestaurantTableStatusDto): Observable<RestResponse<RestaurantTable | null>> {
    return this.http.put<RestResponse<RestaurantTable | null>>(`${this.baseUrl}/update-status/${id}`, dto);
  }
}
